export class Zone {
    constructor(id, name, shape, schedule, time) {
        this.id = id;
        this.name = name;
        this.shape = shape;
        this.schedule = schedule;
        this.time = time;
    }
    //  Copyright (c) 1970-2003, Wm. Randolph Franklin
    //  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
    //  Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimers.
    //  Redistributions in binary form must reproduce the above copyright notice in the documentation and/or other materials provided with the distribution.
    //  The name of W. Randolph Franklin may not be used to endorse or promote products derived from this Software without specific prior written permission.
    //  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
    // nvert - Number of vertices in the polygon. Whether to repeat the first vertex at the end is discussed below.
    // vertx, verty - Arrays containing the x- and y-coordinates of the polygon's vertices.
    // testx, testy - X- and y-coordinate of the test point.
    isInZone({ lon: testx, lat: testy }) {
        let vertx = [];
        let verty = [];
        this.shape.forEach(({ lon, lat }) => {
            verty.push(lon);
            vertx.push(lat);
        });
        let i, j, c = false;
        for (i = 0, j = this.shape.length - 1; i < this.shape.length; j = i++) {
            if (((verty[i] > testy) != (verty[j] > testy)) &&
                (testx < (vertx[j] - vertx[i]) * (testy - verty[i]) / (verty[j] - verty[i]) + vertx[i])) {
                c = !c;
            }
        }
        return c;
    }
}
